module.exports = __webpack_public_path__ + "a072348d74cfac246ee3b83f19385bab.png";